import { Auth } from '@aws-amplify/auth';

export const generatePostHeaders = content => {
    const stringifiedContent = JSON.stringify(content) || '';
    const contentLength = stringifiedContent.length;
    return new Headers({
        'Content-Length': contentLength,
    });
};

export const fetchWithHandledResponse = (requestUrl, requestOptions, responseHandler) => {
    return Auth.currentAuthenticatedUser().then(user => {
        if (user) {
            const tokens = user.signInUserSession;
            const headers = {};

            headers['Authorization'] =
                `Bearer ${tokens.accessToken.jwtToken} ${tokens.idToken.jwtToken} ${tokens.refreshToken.token}`;
            headers['Content-Type'] = 'application/json';
            requestOptions = {
                mode: 'cors',
                ...requestOptions,
                headers,
            };
            return fetch(requestUrl, requestOptions).then(
                responseHandler ? responseHandler : handleResponse
            );
        } else {
            History.push('/logout');
        }
    });
};

export const handleResponse = response => {
    if (response.ok && response.status === 204) {
        return null;
    }

    return response.json().then(data => {
        if (!response.ok) {
            if (response.status === 401) {
                //History.push('/logout');
                Auth.signOut()
                    .then(result => {
                        console.log('signed out', result);
                    })
                    .catch(err => {
                        console.error('error signing out', err);
                    });
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
};
